import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImageCard from '../components/ImageCard/ImageCard';
import places from '../static/places';
import useWindowPosition from '../hook/useWindowPosition';
import DividerWithText from '../components/Utils/Divider';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    minHeight: '50vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  autoer: {
    textAlign: 'center',
  },
}));

export default function About() {
  const classes = useStyles();
  const checked = useWindowPosition('header');

  return (
    <div id='lugar-boda'>
      <DividerWithText>B&U</DividerWithText>
      <div
        className={classes.root}
        style={{
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right',
          backgroundSize: 'auto',
          backgroundImage: `url(${
            process.env.PUBLIC_URL + '/assets/ByU-10.png'
          })`,
        }}
      >
        <ImageCard place={places[0]} checked={checked} />
      </div>
      <DividerWithText>B&U</DividerWithText>
      <div
        className={classes.root}
        style={{
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left',
          backgroundSize: 'auto',
          backgroundImage: `url(${
            process.env.PUBLIC_URL + '/assets/ByU-091.png'
          })`,
        }}
      >
        <ImageCard place={places[1]} checked={checked} />
      </div>
    </div>
  );
}
